import React from 'react';
import PropTypes from 'prop-types';

import { Switch } from '@mui/material';
import moment from 'moment';
import { LbFormControlLabel } from '@infoods/lifebase-ui';

import classes from './DataRangeFilter.module.scss';
import { DateRangePicker } from '../../../../../../shared/components/form-components';
import { SeparatorLine } from '../../../../../../shared/components/ui-components';

const DataRangeFilter = ({
  control,
  isShowConsumptionWidget,
  toggleShowConsumptionWidget,
  customerRegistrationDate,
}) => {
  return (
    <form className={classes.filterBox}>
      <LbFormControlLabel
        control={
          <Switch
            checked={isShowConsumptionWidget}
            onChange={toggleShowConsumptionWidget}
          />
        }
        label="Show Consumption:"
        labelPlacement="start"
        data-test-id="show-consumption-switch"
      />
      <SeparatorLine />
      <DateRangePicker
        control={control}
        size="small"
        variant="outlined"
        startPickerProps={{
          name: 'startDate',
          label: 'Start Date',
          minDate: moment(customerRegistrationDate),
          rules: { required: 'Start date is required' },
        }}
        endPickerProps={{
          name: 'endDate',
          label: 'End Date',
          disableFuture: true,
          rules: { required: 'End date is required' },
        }}
        dataTestId="date-range-picker"
      />
    </form>
  );
};
DataRangeFilter.propTypes = {
  control: PropTypes.object,
  isShowConsumptionWidget: PropTypes.bool,
  toggleShowConsumptionWidget: PropTypes.func,
  customerRegistrationDate: PropTypes.string,
};

export { DataRangeFilter };
